module.exports = __webpack_public_path__ + "static/media/bottom5.afd59390.webp";